import { EChartsOption } from 'echarts';

enum ChartColors {
	line1 = '#4763f6',
	line2 = '#ffa800',
	line3 = '#2EB472',
	line1BackgroundColor = '#8ca0ffe6',
	tooltipLineColor = '#5d78ff',
	tooltipCrossColor = '#1e90ff',
	yAxisSplitLineColor = '#d5dcff3d',
}

export const LinuxUncoveredConfig: EChartsOption = {
	grid: {
		show: false,
		containLabel: true,
	},
	color: [ChartColors.line1, ChartColors.line2, ChartColors.line3],
	legend: {
		show: true,
		top: '10%',
		icon: 'circle',
		itemGap: 40,
	},
	tooltip: {
		borderWidth: 0,
		backgroundColor: 'rgba(64, 64, 64, 0.8)',
		textStyle: {
			color: 'white',
		},
		trigger: 'axis',
		padding: 8,
		axisPointer: {
			type: 'line',
			lineStyle: {
				color: ChartColors.tooltipLineColor,
				width: 1,
				type: 'dashed',
			},
			crossStyle: {
				color: ChartColors.tooltipCrossColor,
				width: 1,
				type: 'dashed',
			},
		},
	},
	xAxis: {
		show: true,
		name: 'Day',
		nameLocation: 'middle',
		nameGap: 30,
		type: 'category',
		data: [],
		boundaryGap: false,
		splitLine: { show: false },
		axisLine: { show: false },
	},
	yAxis: {
		show: true,
		name: 'VM OD Cost',
		nameLocation: 'middle',
		nameGap: 50,
		type: 'value',
		min: '0',
		scale: false,
		splitLine: {
			show: true,
			lineStyle: {
				color: ChartColors.yAxisSplitLineColor,
				type: 'dashed',
			},
		},
		axisLabel: {
			formatter: function (value) {
				return +value + ' ' + '-';
			},
		},
		axisLine: { show: false },
	},
	series: [
		{
			name: 'Linux VMs Uncovered OD',
			type: 'line',
			smooth: false,
			lineStyle: { color: ChartColors.line1 },
			areaStyle: { color: ChartColors.line1BackgroundColor },
			showSymbol: false,
			data: [],
			animationDelay: (idx) => idx * 10,
		},
		{
			name: 'VMs steady state',
			type: 'line',
			smooth: false,
			lineStyle: { color: ChartColors.line2, type: 'dashed' },
			areaStyle: { opacity: 0 },
			showSymbol: false,
			data: [],
			animationDelay: (idx) => idx * 10 + 100,
		},
	],
	animationEasing: 'elasticOut',
	animationDelayUpdate: (idx) => idx * 5,
};
